export default __webpack_public_path__ + "static/media/pic2.60a50a87.jpg";